<template>
  <b-row v-if="summary" class="match-height">
    <!-- Total Geral -->
    <b-col cols="12" md="3">
      <b-card no-body class="bg-primary text-white text-center p-1">
        <small class="text-white-50 d-block mb-50">Total Geral</small>
        <h4 class="text-white mb-0">R$ {{ summary.totalGeral.toFixed(2) }}</h4>
        <div class="mt-50">
          <small v-if="summary.totalJuros > 0" class="d-block">+ R$ {{ summary.totalJuros.toFixed(2) }} (Juros)</small>
          <small v-if="summary.totalDescontos > 0" class="d-block">- R$ {{ summary.totalDescontos.toFixed(2) }} (Desc)</small>
        </div>
      </b-card>
    </b-col>

    <!-- Total Pago -->
    <b-col cols="12" md="3">
      <b-card no-body class="bg-success text-white text-center p-1">
        <small class="text-white-50 d-block mb-50">Total Pago</small>
        <h4 class="text-white mb-0">R$ {{ summary.totalPago.toFixed(2) }}</h4>
        <b-progress :value="summary.percentualLiquidacao" variant="white" height="6px" class="mt-1" />
        <small class="mt-50 d-block">{{ summary.percentualLiquidacao }}% Liquidado</small>
      </b-card>
    </b-col>

    <!-- Saldo Devedor -->
    <b-col cols="12" md="3">
      <b-card no-body class="bg-warning text-white text-center p-1">
        <small class="text-white-50 d-block mb-50">Saldo Devedor</small>
        <h4 class="text-white mb-0">R$ {{ summary.saldoDevedor.toFixed(2) }}</h4>
        <small class="mt-50 d-block">A vencer</small>
      </b-card>
    </b-col>

    <!-- Valor Vencido -->
    <b-col cols="12" md="3">
      <b-card no-body :class="summary.valorVencido > 0 ? 'bg-danger' : 'bg-secondary'" class="text-white text-center p-1">
        <small class="text-white-50 d-block mb-50">Valor Vencido</small>
        <h4 class="text-white mb-0">R$ {{ summary.valorVencido.toFixed(2) }}</h4>
        <small class="mt-50 d-block" v-if="summary.valorVencido > 0">Atenção: Atraso detectado</small>
        <small class="mt-50 d-block" v-else>Em dia</small>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BProgress } from 'bootstrap-vue'

export default {
  components: { BRow, BCol, BCard, BProgress },
  props: {
    summary: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.card {
  transition: all 0.3s ease;
}
.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2) !important;
}
</style>
